import React from "react";
import { getBcp47Locale } from "lib/dateLocale";
import "./style.scss";

interface EditEntry {
  id: string;
  messageId: string;
  previousText: string;
  newText: string;
  editedBy: string;
  editedByUser?: { screenName?: string } | null;
  editedTime: string;
}

interface Props {
  edits: EditEntry[];
  onClose: () => void;
}

function formatEditTime(time: string): string {
  const d = new Date(time);
  return d.toLocaleString(getBcp47Locale(), {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

function EditHistoryModal({ edits, onClose }: Props) {
  return (
    <div className="edit-history-modal">
      <div className="edit-history-modal__overlay" onClick={onClose} />
      <div className="edit-history-modal__content">
        <div className="edit-history-modal__header">
          <h3>История редактирования</h3>
          <button className="edit-history-modal__close" onClick={onClose} type="button">
            ✕
          </button>
        </div>
        <div className="edit-history-modal__list">
          {edits.length === 0 ? (
            <div className="edit-history-modal__empty">Нет изменений</div>
          ) : (
            edits.map((edit) => (
              <div key={edit.id} className="edit-history-modal__item">
                <div className="edit-history-modal__meta">
                  <span className="edit-history-modal__time">{formatEditTime(edit.editedTime)}</span>
                  {edit.editedByUser?.screenName && (
                    <span className="edit-history-modal__editor">{edit.editedByUser.screenName}</span>
                  )}
                </div>
                <div className="edit-history-modal__diff">
                  <div className="edit-history-modal__old-text">{edit.previousText}</div>
                  <div className="edit-history-modal__new-text">{edit.newText}</div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default EditHistoryModal;
